import { ImageEntity } from "~/interfaces/entities/Image"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: images, selectors: imagesSelectors } = createEntitySlice<
  ImageEntity
>("images")
